import axios from 'axios';
import API from './API';


export const Buildings_Add = (data) => API.post('Buildings/Add', data);
export const Buildings_Get_All = () => {
  return API.get("Buildings/Get_All");
};
export const Buildings_Get = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Buildings/Get/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Buildings_Update = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Buildings/Update/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
export const Buildings_Delete = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.delete(`Buildings/Delete/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Buildings_Restore_Single = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Buildings/Restore/${ID}`,
    {},
    {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Buildings_Restore_Cascade = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Buildings/Restore_Cascade/${ID}`,
    {},
    {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}
